import { render } from "./QuestionFeedCard.vue?vue&type=template&id=0c10e09d&scoped=true"
import script from "./QuestionFeedCard.vue?vue&type=script&lang=js"
export * from "./QuestionFeedCard.vue?vue&type=script&lang=js"

import "./QuestionFeedCard.vue?vue&type=style&index=0&id=0c10e09d&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c10e09d"]])

export default __exports__